import React from 'react'
import "./listEvent.scss";
import CardEvent from '../../../../components/cardEvent/CardEvent'
import { isEmpty } from '../../../../utils/validation';

const ListEvent = ({ title, data }) => {
    return (
        <div className='list-event-container'>
            {title ? <div className="title">{title}</div> : null}
            <div className="list-event">
                {!isEmpty(data) ? data.map(item =>
                    <CardEvent
                        key={item.id}
                        id={item.id}
                        title={item.name}
                        associationName={item.info_association.name}
                        eventAddress={item.address}
                        startDatetime={item.start_date}
                        isLike={item.is_like}
                        numberLike={item.number_like}
                        photo={item.photo[0]}
                    />

                ) : null}
            </div>
        </div>
    )
}

export default ListEvent
